import {
    REFRESH_SESSION_ERROR,
    REFRESH_SESSION_START,
    REFRESH_SESSION_SUCCESS,
    REFRESH_SESSION_RESET
} from "../actions/refreshSession";

const defaultState = {
    status: {
        started: false,
        error: false,
        ended: false,
        errorInfo: {
            code: "",
            message: ""
        }
    }
};

export function refreshSession(state = defaultState, { type, payload, error }) {
    switch (type) {
        case REFRESH_SESSION_START:
            return {
                ...defaultState,
                status: {
                    started: true,
                    error: false,
                    ended: false
                }
            };
        case REFRESH_SESSION_SUCCESS:
            return {
                status: {
                    started: false,
                    error: false,
                    ended: true
                },
                payload
            };
        case REFRESH_SESSION_ERROR:
            return {
                status: {
                    started: false,
                    error: true,
                    ended: false,
                    errorInfo: { message: error.message }
                }
            };
        case REFRESH_SESSION_RESET:
            return {
                ...defaultState
            };
        default:
            return state;
    }
}
